export default __webpack_public_path__ + "static/media/footer-email.dfa3706e.svg";